import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { Share } from '../../../core/models/mysec/share';
import { SharesPortfolio } from '../../../core/models/mysec/share-portfolio';
import { PortfolioService } from '../../../core/services/api/portfolio.service';
import { ErrorService } from '../../../core/services/error.service';
import { ShareDetailsComponent } from './share-details/share-details.component';

@Component({
    selector: 'app-mysec-shares',
    templateUrl: './mysec-shares.component.html',
    styleUrls: ['./mysec-shares.component.scss'],
    standalone: false
})
export class MysecSharesComponent implements OnInit {
  displayColumns: string[] = [
    'Company',
    'TickerCode',
    'ShareQty',
    'PurchasedPrice',
    'MarketPrice',
    'Profit',
    'Action',
  ];
  params = {
    currentPage: 1,
    take: 10,
  };
  isLoading: boolean = false;
  total: number;
  shares: Share[];
  mySharesPortfolio: SharesPortfolio;

  constructor(
    private errorService: ErrorService,
    private portfolioService: PortfolioService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.getPortfolio();
  }

  getPortfolio(reload?: boolean) {
    if (reload) this.params.currentPage = 1;

    this.isLoading = true;

    this.portfolioService
      .getPortfolio(this.params.take, this.params.currentPage)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.shares = data.data;
          this.total = data.total;
        },
        (err) => {
          this.errorService.showError(err);
        },
      );
  }

  changePage(event?: PageEvent) {
    this.params.currentPage = event.pageIndex + 1;
    this.params.take = event.pageSize;
    this.getPortfolio();
  }

  viewDetails(shareDetails: Share) {
    const popupOptions = {
      size: 'md',
      centered: true,
      keyboard: false,
    } as NgbModalOptions;

    const modalRef = this.modalService.open(ShareDetailsComponent, popupOptions);
    modalRef.componentInstance.shareDetails = shareDetails;
    modalRef.result.then(
      () => {},
      () => {},
    );
  }
}
